const GLYPHS: Readonly<Record<string, string>> = {
    '…': 'M0 8 L0 8 M4 8 L4 8',
    A: 'M0 8 L0 2 Q0 0 2 0 Q4 0 4 2 L4 8 M0 4 L4 4',
    B: 'M0 8 L0 0 L2 0 Q4 0 4 2 Q4 4 2 4 L0 4 M2 4 Q4 4 4 6 Q4 8 2 8 L0 8',
    C: 'M4 1 Q3 0 2 0 Q0 0 0 2 L0 6 Q0 8 2 8 Q3 8 4 7',
    D: 'M0 0 L1 0 Q4 0 4 3 L4 5 Q4 8 1 8 L0 8 Z',
    E: 'M4 0 L0 0 L0 8 L4 8 M0 4 L3 4',
    F: 'M4 0 L0 0 L0 8 M0 4 L3 4',
    G: 'M4 1 Q3 0 2 0 Q0 0 0 2 L0 6 Q0 8 2 8 Q4 8 4 6 L4 4 L2 4',
    H: 'M0 0 L0 8 M4 0 L4 8 M0 4 L4 4',
    I: 'M0 0 L4 0 M2 0 L2 8 M0 8 L4 8',
    J: 'M0 0 L4 0 L4 6 Q4 8 2 8 Q0 8 0 6',
    K: 'M0 0 L0 8 M4 0 L0 4 L4 8',
    L: 'M0 0 L0 8 L4 8',
    M: 'M0 8 L0 0 L2 4 L4 0 L4 8',
    N: 'M0 8 L0 0 L4 8 L4 0',
    O: 'M2 0 Q4 0 4 2 L4 6 Q4 8 2 8 Q0 8 0 6 L0 2 Q0 0 2 0 Z',
    P: 'M0 8 L0 0 L2 0 Q4 0 4 2 Q4 4 2 4 L0 4',
    Q: 'M2 0 Q4 0 4 2 L4 6 Q4 8 2 8 Q0 8 0 6 L0 2 Q0 0 2 0 Z M2 6 L4 8',
    R: 'M0 8 L0 0 L2 0 Q4 0 4 2 Q4 4 2 4 L0 4 M2 4 L4 8',
    S: 'M4 1 Q3 0 2 0 Q0 0 0 2 Q0 4 2 4 Q4 4 4 6 Q4 8 2 8 Q1 8 0 7',
    T: 'M0 0 L4 0 M2 0 L2 8',
    U: 'M0 0 L0 6 Q0 8 2 8 Q4 8 4 6 L4 0',
    V: 'M0 0 L2 8 L4 0',
    W: 'M0 0 L0 8 L2 4 L4 8 L4 0',
    X: 'M0 0 L4 8 M4 0 L0 8',
    Y: 'M0 0 L2 4 L4 0 M2 4 L2 8',
    Z: 'M0 0 L4 0 L0 8 L4 8',
    '0': 'M2 0 Q4 0 4 2 L4 6 Q4 8 2 8 Q0 8 0 6 L0 2 Q0 0 2 0 Z',
    '1': 'M0 2 L2 0 L2 8 M0 8 L4 8',
    '2': 'M0 1 Q1 0 2 0 Q4 0 4 2 Q4 3 2 5 L0 8 L4 8',
    '3': 'M0 0 L2 0 Q4 0 4 2 Q4 4 2 4 M1 4 L2 4 Q4 4 4 6 Q4 8 2 8 L0 8',
    '4': 'M0 0 L0 4 L4 4 M4 0 L4 8',
    '5': 'M4 0 L0 0 L0 4 L2 4 Q4 4 4 6 Q4 8 2 8 L0 8',
    '6': 'M4 0 L2 0 Q0 0 0 2 L0 6 Q0 8 2 8 Q4 8 4 6 Q4 4 2 4 L0 4',
    '7': 'M0 0 L4 0 L1 8',
    '8': 'M2 0 Q4 0 4 2 Q4 4 2 4 Q0 4 0 2 Q0 0 2 0 Z M2 4 Q4 4 4 6 Q4 8 2 8 Q0 8 0 6 Q0 4 2 4 Z',
    '9': 'M4 4 L2 4 Q0 4 0 2 Q0 0 2 0 Q4 0 4 2 L4 6 Q4 8 2 8 L0 8',
};

const FILE_OUTLINE =
    '<path d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2Z"/><path d="M14 2v5a1 1 0 0 0 1 1h5"/>';
const LABELLED_OUTLINE =
    '<path d="M4 10.5V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v2.5"/><path d="M14 2v5a1 1 0 0 0 1 1h5"/>';

export function toFileTypeSvg(extension: string): string {
    const label =
        extension.length > 4
            ? `${extension.slice(0, 3).toUpperCase()}…`
            : extension.toUpperCase();
    const paths = /^[a-z0-9]+$/i.test(extension)
        ? LABELLED_OUTLINE + toGlyphPaths(label)
        : FILE_OUTLINE;

    return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" style="overflow:visible;stroke-width:var(--ng-icon__stroke-width, 2)" stroke-linecap="round" stroke-linejoin="round">${paths}</svg>`;
}

function toGlyphPaths(label: string): string {
    const start = 12 - ((label.length - 1) * 7.5 + 4) / 2;

    return Array.from(label, (letter, index) => {
        let coordinate = 0;
        const path = GLYPHS[letter].replace(/-?\d+(?:\.\d+)?/g, (value) =>
            String(
                Number(value) +
                    (coordinate++ % 2 === 0 ? start + index * 7.5 : 14)
            )
        );
        return `<path d="${path}"/>`;
    }).join('');
}
